<template>
  <svg
    width="7"
    height="6"
    viewBox="0 0 7 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.14388 5.91634L0.560547 5.33301L2.89388 2.99967L0.560547 0.666341L1.14388 0.0830078L3.47721 2.41634L5.81055 0.0830078L6.39388 0.666341L4.06055 2.99967L6.39388 5.33301L5.81055 5.91634L3.47721 3.58301L1.14388 5.91634Z"
      fill="#666666"
    />
  </svg>
</template>
